














































































import Vue from 'vue';

import store from '@/store';
import { WorkflowStep } from '@/store/getStarted';

import FindOrCreatePacketBranch from '@/components/getStarted/FindOrCreatePacketBranch.vue';
import FinishOrRetry from '@/components/getStarted/FinishOrRetry.vue';
import GettingStartedIsEasy from '@/components/getStarted/GettingStartedIsEasy.vue';
import GoogleClassroomCourses from '@/components/getStarted/GoogleClassroomCourses.vue';
import GroupTypeBranch from '@/components/getStarted/GroupTypeBranch.vue';
import LostUser from '@/components/getStarted/LostUser.vue';
import ManualGroupBuilder from '@/components/getStarted/ManualGroupBuilder.vue';
import NewPacketKindBranch from '@/components/getStarted/NewPacketKindBranch.vue';
import PublicPacketPicker from '@/components/getStarted/PublicPacketPicker.vue';
import Review from '@/components/getStarted/Review.vue';
import WorkflowPacketBuilder from '@/components/getStarted/WorkflowPacketBuilder.vue';
import {
  renderSignInButton,
  SignInResponse,
  SignInText
} from '@/api/auth/google';

export default Vue.extend({
  components: {
    FindOrCreatePacketBranch,
    FinishOrRetry,
    GettingStartedIsEasy,
    GoogleClassroomCourses,
    GroupTypeBranch,
    LostUser,
    ManualGroupBuilder,
    NewPacketKindBranch,
    PublicPacketPicker,
    Review,
    WorkflowPacketBuilder
  },

  props: {
    stepNo: {
      type: Number,
      default: 0
    },
    isPacketDetailsOpen: {
      type: Boolean,
      required: true
    },
    accountType: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      WorkflowStep: WorkflowStep
    };
  },

  computed: {
    step(): WorkflowStep {
      return store.state.getStarted.step;
    },

    signingIn(): boolean {
      return store.state.getStarted.isSigningIn;
    }
  },

  methods: {
    signInWithGoogle(response: SignInResponse) {
      store.dispatch.getStarted.setAccountType(this.accountType || 'unset');

      store.dispatch.getStarted.getStartedWithGoogle(response.idToken);
    },

    signInWithMicrosoft() {
      store.dispatch.getStarted.setAccountType(this.accountType || 'unset');

      store.dispatch.getStarted.getStartedWithMicrosoft();
    }
  },

  mounted() {
    renderSignInButton(
      this.$refs.googleLoginButton,
      SignInText.signUpWith,
      this.signInWithGoogle
    );
  },

  watch: {
    // Changes to the url propagate to the store here
    stepNo: {
      immediate: true,
      handler(current) {
        if (current !== this.step) {
          // Check if we have a firebaseUser in the workflow.  If we don't, the user
          // has navigated here directly (as opposed to a forward/back in the browser)
          // and we should kick them to the start of the workflow;
          if (
            current !== WorkflowStep.SIGN_IN &&
            !store.state.getStarted.firebaseUser
          ) {
            this.$router.replace({
              params: { stepNo: `${WorkflowStep.SIGN_IN}` }
            });
            return;
          }

          store.dispatch.getStarted.goToStep(current);
        }
      }
    },

    // Changes to the store propagate to route here
    step: {
      immediate: true,
      handler(current) {
        if (current !== this.stepNo) {
          this.$router.push({
            params: { stepNo: `${current}` }
          });
        }
      }
    }
  }
});
